import * as  stringUtil from '../string/stringUtil';
import * as stateManager from '../state/stateManager';
import * as  configurationManager from '../config/configurationManager';

const logger = require('../logger/logger.js');
const utils = require('../logger/utils');
const validator = require('../validator/validator');
const translator = require('../translator/translator');

export const defaultTimeoutInSeconds = 10;

export function getOrgContextToUrl()
{
    const orgData = stateManager.getStore().getState().orgData;
    return `core/organizations/${orgData.franchisor.id}/${orgData.franchisee.id}/${orgData.property.id}`;
} 

export function getFranchisorOrgContextUrl()
{
    const orgData = stateManager.getStore().getState().orgData;
    return `core/organizations/${orgData.franchisor.id}`;
}

export function getFranchiseeOrgContextUrl()
{
    const orgData = stateManager.getStore().getState().orgData;
    return `core/organizations/${orgData.franchisor.id}/${orgData.franchisee.id}`;
}


export function get(resourceUrls, timeoutInSeconds)
{
    const isArrayGiven = Array.isArray(resourceUrls);
    if (!isArrayGiven)
    {
        resourceUrls = [resourceUrls];
    }

    const allPromises = [];
    resourceUrls.forEach(resourceUrl =>
    {
        const promise = getFetch(resourceUrl, timeoutInSeconds);
        allPromises.push(promise);
    });

    return Promise.all(allPromises)
        .then(
            results =>
            {
                if (!isArrayGiven)
                    return results[0];
                else
                    return results;
            },
            error =>
            {
                return Promise.reject(error);
            });
}

export function post(resourceUrl, body, timeoutInSeconds)
{
    return postFetch(resourceUrl, body, timeoutInSeconds);
}

export function put(resourceUrl, body, timeoutInSeconds)
{
    return putFetch(resourceUrl, body, timeoutInSeconds);
}

export function deleted(resourceUrl, timeoutInSeconds)
{
    return deleteFetch(resourceUrl, timeoutInSeconds);
}

function getFetch(url, timeoutInSeconds)
{
    const requestUrl = getCompleteUrl(url);

    const requestBody = {
        method: 'GET',
        headers: getHttpHeader(url, "GET"),
        signal: getTimeoutSignal(timeoutInSeconds)
    };

    return doFetch(requestUrl, requestBody);
}

function postFetch(url, body, timeoutInSeconds)
{
    const requestUrl = getCompleteUrl(url);

    const requestBody = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: getHttpHeader(url, "POST"),
        signal: getTimeoutSignal(timeoutInSeconds)
    };

    return doFetch(requestUrl, requestBody);
}

function putFetch(url, body, timeoutInSeconds)
{
    const requestUrl = getCompleteUrl(url);

    const requestBody = {
        method: 'PUT',
        body:  body != null ? JSON.stringify(body) : undefined,
        headers: getHttpHeader(url, "PUT"),
        signal: getTimeoutSignal(timeoutInSeconds)
    };

    return doFetch(requestUrl, requestBody);
}

function deleteFetch(url, timeoutInSeconds)
{
    const requestUrl = getCompleteUrl(url);

    const requestBody = {
        method: 'DELETE',
        headers: getHttpHeader(url, "DELETE"),
        signal: getTimeoutSignal(timeoutInSeconds)
    };

    return doFetch(requestUrl, requestBody);
}

function getTimeoutSignal(timeoutInSeconds)
{
    try
    {
        if (timeoutInSeconds == null || !validator.isInteger(timeoutInSeconds))
            timeoutInSeconds = defaultTimeoutInSeconds;

        let controller = new AbortController();
        setTimeout(() => controller.abort(), timeoutInSeconds * 1000);
        return controller.signal;
    }
    catch(error)
    {
        logger.warn(`Error occurred while creating the abort signal. ${error}`, {}, error);
        return null;
    }
}

function doFetch(requestUrl, requestBody)
{
    var tracingContext = JSON.parse(requestBody.headers["tracing-context"]);
    logger.info(`Sending request to URL: ${requestUrl}`, tracingContext);
    
    return fetch(requestUrl, requestBody)
        .then(
            response =>
            {
                if (response.status < 200 || response.status > 299)
                {
                    return response.text()
                            .then(text => Promise.reject(text || `Server returned response with status ${response.status}`));
                }

                logger.info(`Response received from URL: ${requestUrl}`, tracingContext);
                return response.json();
            },
            error => 
            {
                let errorMessage;
                if (requestBody != null && requestBody.signal != null && requestBody.signal.aborted)
                    errorMessage = `${translator.getLabel("timeout_error_please_check_your_internet_connection_and_try_again")}`;
                else
                {
                    errorMessage = error.message;
                    if (!errorMessage) errorMessage = error.toString();
                    errorMessage = `${translator.getLabel("please_check_your_internet_connection")}\n${errorMessage}`;
                }

                logger.error(`Following error reported while accessing resource URL '${requestUrl}' with method '${requestBody.method}':  ${errorMessage}`, tracingContext, error);
                return Promise.reject(errorMessage);
            });
}


function getHttpHeader(url, verb)
{
    const headers = {
        "Content-Type": "application/json",
        "tracing-context": JSON.stringify(utils.createTracingContext(url, verb))
    };

    const state = stateManager.getStore().getState();

    if (state.passport != null)
    {
        headers["x-token"] = state.passport.token;
    }

    return headers;
}

function getCompleteUrl(url)
{
    if (stringUtil.isStringNullOrEmpty(url))
        return url;

    const baseUrl = configurationManager.getConfig().apiServer;
    return `${baseUrl}/${url}`;
}